import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { AvailableTypesTrackColors } from '@common/components/create-object/tabs/object-sensors-tab/create-sensors.service';
import { SortOrder } from '@common/utils/search-sort';
import { CreateTrackParams } from '@services/tracks.service';

export enum AvailableTabsOnReportsPage {
  Form = 'form',
  Result = 'result',
  Templates = 'templates',
  Mailing = 'mailing',
}

export interface LastReportsPageStateWithTabs {
  activeTabOnPage: AvailableTabsOnReportsPage;
  searchValue: string;
  sortOrder: SortOrder;
  paramsCreateTrack: Record<string, CreateTrackParams>;
}

export interface TemplateTrackSettings {
  buildTrack: boolean;
  colorMode: AvailableTypesTrackColors;
  color: string;
  lineThickness: number;
  detectorTrips: boolean;
  markers: {
    isStartAndEndPosition: boolean;
    isParking: boolean;
    isStop: boolean;
    isSpeedLimit: boolean;
    isGasStation: boolean;
    isPlum: boolean;
  };
}

export interface ReportTemplateItem {
  id: number;
  name: string;
  currentUserAccess: ('view' | 'edit' | 'delete')[];
  trackSettings: TemplateTrackSettings;
}

export interface RawReportTemplateItem {
  id: number;
  name: string;
  currentUserAccess: number | ('view' | 'edit' | 'delete')[];
  trackSettings: TemplateTrackSettings;
}

export type ReportTemplatesList = ReportTemplateItem[];

export interface ReportsState extends EntityState<ReportTemplateItem> {
  lastPageState: LastReportsPageStateWithTabs;
  loading: boolean;
  error?: string;
}

export const reportTemplateAdapter = createEntityAdapter<ReportTemplateItem>({
  selectId: (item) => item.id as number,
});

export const initialStateReports: ReportsState = reportTemplateAdapter.getInitialState({
  lastPageState: {
    activeTabOnPage: AvailableTabsOnReportsPage.Form,
    searchValue: '',
    sortOrder: SortOrder.Asc,
    paramsCreateTrack: {},
  },
  loading: false,
  error: undefined,
});
